import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { specraFocusRing } from './focus-ring';
/** Branded single-line field for product forms and filter controls. */ export const SpecraInput = /*#__PURE__*/ React.forwardRef(({ className, invalid = false, ...props }, ref)=>/*#__PURE__*/ _jsx("input", {
        "aria-invalid": invalid || undefined,
        className: cn('h-[var(--control-height-md)] w-full rounded-[var(--radius-control)] border border-input bg-card px-[var(--space-2-5)] text-[length:var(--fs-ui)] text-foreground placeholder:text-[color:var(--text-placeholder)] disabled:cursor-not-allowed disabled:opacity-50', specraFocusRing, invalid && 'border-danger', className),
        ref: ref,
        ...props
    }));
SpecraInput.displayName = 'SpecraInput';
